import { render, staticRenderFns } from "./EditCustomerComponent.vue?vue&type=template&id=22e748a6&"
import script from "./EditCustomerComponent.vue?vue&type=script&lang=js&"
export * from "./EditCustomerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports